const initialState = {
	constants: null,
	loading: false,
	error: null,
	required_vaccines: []
}

const constants = (state = initialState, action) => {
	switch (action.type) {
		case 'RESET_APP':
			return { ...initialState }
		case 'GET_CONSTANTS':
			return { ...state, loading: true, error: null }
		case 'GET_CONSTANTS_SUCCESS':
			return {
				...state,
				constants: action.payload.constants,
				required_vaccines: action.payload.required_vaccines,
				loading: false,
				error: null
			}
		case 'GET_CONSTANTS_FAIL':
			return { ...state, loading: false, error: action.payload }
		default:
			return state
	}
}

export default constants
